export default __webpack_public_path__ + "static/media/settings-light.391c59db.svg";